import type { BreadcrumbItem } from '#main/app/components/ho/HoAdminBreadcrumb.vue'

export function useAdminBreadcrumbs() {
  const breadcrumbs = useState<BreadcrumbItem[]>('admin-breadcrumbs', () => [])

  function setBreadcrumbs(items: BreadcrumbItem[]): void {
    breadcrumbs.value = items
  }

  return { breadcrumbs, setBreadcrumbs }
}
